import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
  KtMap140uvy3s5zad8 as KtMap,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import {
  mapOf2zpbbmyqk8xpf as mapOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from './collectionJs.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from './LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { getOrImplicitDefault24g3b5txuslgw as getOrImplicitDefault } from './MapWithDefault.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from './HashMap.mjs';
import { EmptySet_instance5gmcv6efr8wg as EmptySet_instance } from './Sets.mjs';
import { EmptyList_instanceq4z55tiumr5b as EmptyList_instance } from './CollectionsKt.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toMap(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.q2()) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.r2(0);
        } else {
          tmp_0 = _this__u8e3s4.p1().r1();
        }

        tmp = mapOf(tmp_0);
        break;
      default:
        tmp = toMap_1(_this__u8e3s4, LinkedHashMap().gc(mapCapacity(_this__u8e3s4.q2())));
        break;
    }
    return tmp;
  }
  return optimizeReadOnlyMap(toMap_1(_this__u8e3s4, LinkedHashMap().fc()));
}
function mapOf_0(pairs) {
  return pairs.length > 0 ? toMap_2(pairs, LinkedHashMap().gc(mapCapacity(pairs.length))) : emptyMap();
}
function plus(_this__u8e3s4, map) {
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().hc(_this__u8e3s4);
  this_0.d5(map);
  return this_0;
}
function toMap_0(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.q2()) {
    case 0:
      tmp = emptyMap();
      break;
    case 1:
      // Inline function 'kotlin.collections.toSingletonMap' call

      tmp = toMutableMap(_this__u8e3s4);
      break;
    default:
      tmp = toMutableMap(_this__u8e3s4);
      break;
  }
  return tmp;
}
function plus_0(_this__u8e3s4, pairs) {
  var tmp;
  if (_this__u8e3s4.n1()) {
    tmp = toMap(pairs);
  } else {
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap().hc(_this__u8e3s4);
    putAll(this_0, pairs);
    tmp = this_0;
  }
  return tmp;
}
function emptyMap() {
  var tmp = EmptyMap_instance;
  return isInterface(tmp, KtMap()) ? tmp : THROW_CCE();
}
function toMutableMap(_this__u8e3s4) {
  return LinkedHashMap().hc(_this__u8e3s4);
}
function getValue(_this__u8e3s4, key) {
  return getOrImplicitDefault(_this__u8e3s4, key);
}
function hashMapOf(pairs) {
  // Inline function 'kotlin.apply' call
  var this_0 = HashMap().g9(mapCapacity(pairs.length));
  putAll_0(this_0, pairs);
  return this_0;
}
function toMap_1(_this__u8e3s4, destination) {
  // Inline function 'kotlin.apply' call
  putAll(destination, _this__u8e3s4);
  return destination;
}
function optimizeReadOnlyMap(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.q2()) {
    case 0:
      tmp = emptyMap();
      break;
    case 1:
      // Inline function 'kotlin.collections.toSingletonMapOrSelf' call

      tmp = _this__u8e3s4;
      break;
    default:
      tmp = _this__u8e3s4;
      break;
  }
  return tmp;
}
function toMap_2(_this__u8e3s4, destination) {
  // Inline function 'kotlin.apply' call
  putAll_0(destination, _this__u8e3s4);
  return destination;
}
function putAll(_this__u8e3s4, pairs) {
  var _iterator__ex2g4s = pairs.p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    var key = _destruct__k2r9zo.df();
    var value = _destruct__k2r9zo.ef();
    _this__u8e3s4.b5(key, value);
  }
}
var EmptyMapClass;
function EmptyMap() {
  if (EmptyMapClass === VOID) {
    class $ {
      constructor() {
        this.qk_1 = 8246714829545688274n;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtMap()) : false) {
          tmp = other.n1();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '{}';
      }
      q2() {
        return 0;
      }
      n1() {
        return true;
      }
      rk(key) {
        return false;
      }
      t4(key) {
        if (!true)
          return false;
        return this.rk(key);
      }
      sk(key) {
        return null;
      }
      v4(key) {
        if (!true)
          return null;
        return this.sk(key);
      }
      l3() {
        return EmptySet_instance;
      }
      w4() {
        return EmptySet_instance;
      }
      x4() {
        return EmptyList_instance;
      }
    }
    initMetadataForObject($, 'EmptyMap', VOID, VOID, [KtMap()]);
    EmptyMapClass = $;
  }
  return EmptyMapClass;
}
var EmptyMap_instance;
function EmptyMap_getInstance() {
  return EmptyMap_instance;
}
function putAll_0(_this__u8e3s4, pairs) {
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.df();
    var value = _destruct__k2r9zo.ef();
    _this__u8e3s4.b5(key, value);
  }
}
function mutableMapOf(pairs) {
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().gc(mapCapacity(pairs.length));
  putAll_0(this_0, pairs);
  return this_0;
}
function minus(_this__u8e3s4, key) {
  // Inline function 'kotlin.apply' call
  var this_0 = toMutableMap(_this__u8e3s4);
  // Inline function 'kotlin.collections.minusAssign' call
  this_0.c5(key);
  return optimizeReadOnlyMap(this_0);
}
//region block: init
EmptyMap_instance = new (EmptyMap())();
//endregion
//region block: exports
export {
  emptyMap as emptyMapr06gerzljqtm,
  getValue as getValue48kllevslyh6,
  hashMapOf as hashMapOf2phwdlwszpif7,
  mapOf_0 as mapOf1xd03cq9cnmy8,
  minus as minus1f3bieyodk5vw,
  mutableMapOf as mutableMapOfk2y3zt1azl40,
  plus as plus2m1vv33moko5t,
  plus_0 as plus1so6nizi7tpx6,
  toMap_0 as toMapcf6xfku344cz,
  toMap as toMap1vec9topfei08,
  toMutableMap as toMutableMapr5f3w62lv8sk,
};
//endregion

//# sourceMappingURL=Maps.mjs.map
